import React from 'react'
import { connect } from 'react-redux';

import './../css/Home.css';

import Recipe from './Recipe';

var json = require('./../recipes.json');

class Home extends React.Component{


    constructor(props){
        super(props)

        this.state = {
            recipes: [],
            allRecipes: [],
            filteredRecipes: []
        }
    }

    componentDidMount(){
        this.setState(() => {
            let recipes = [];
            recipes = json.map((recipe) => {
                return (
                    <Recipe recipe={recipe}></Recipe>
                )
            })
            return (
                {
                    recipes: recipes,
                    allRecipes: recipes,
                    filteredRecipes: recipes,
                }
            )
        })
    }

    componentDidUpdate(prevProps){
        console.log(this.props)

        if (prevProps.filterType !== this.props.filterType)
        {
            let recipes = [];
            if (this.props.filterType){
                json.forEach((recipe) => {
                    if(recipe.type === this.props.filterType)
                        recipes.push(<Recipe recipe={recipe}></Recipe>);
                })
                this.setState({
                    recipes: recipes,
                    filteredRecipes: recipes
                })
            }
            else   
                this.setState({
                    recipes: this.state.allRecipes,
                    filteredRecipes: this.state.allRecipes
                })       
        }
    }

    applySearch = (e) => {
        if (e.target.value !== ""){
            let searchValue = e.target.value.toLowerCase();
            let newRecipes = [];
            this.setState(() => {
                console.log("this.state", this.state)
                this.state.recipes.forEach((recipe) => {
                    if (recipe.props.recipe.name.toLowerCase().includes(searchValue))
                        newRecipes.push(recipe)
                })
                return(
                    {
                        recipes: newRecipes
                    }
                )
            })
        }
        else {
            this.setState({recipes: this.state.filteredRecipes})
        }
    }

    render() {
        return (
            <div className='Body'>
                <input className='FilterBar' type='text' placeholder='Search...' onChange={this.applySearch}/>
                <div className='RecipesContainer'>
                    {this.state.recipes.sort((a, b) => a.props.recipe.name.localeCompare(b.props.recipe.name))}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state){
    return{
        filterType: state.filterType
    }
}

export default connect(mapStateToProps)(Home);